import Skeleton from '@mui/material/Skeleton'

const TYPE_LABELS = {
  platform_error: 'Error de plataforma',
  payment_refund: 'Reembolso de pago'
}

const STATUS_LABELS = {
  created: 'Creado',
  in_review: 'En revisión',
  solved: 'Resuelto'
}

const STATUS_COLORS = {
  created: 'bg-yellow-100 text-yellow-800',
  in_review: 'bg-blue-100 text-blue-800',
  solved: 'bg-green-100 text-green-800'
}

export const TicketsListSkeleton = () => {
  return (
    <div className='space-y-4'>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className='border rounded-lg p-4'>
          <div className='flex justify-between items-start mb-2'>
            <div className='flex-1'>
              <Skeleton variant='text' width='60%' height={24} className='mb-2' />
              <Skeleton variant='text' width='40%' height={20} />
            </div>
            <Skeleton variant='rounded' width={100} height={24} />
          </div>
          <Skeleton variant='text' width='30%' height={16} />
        </div>
      ))}
    </div>
  )
}

export const TicketsList = ({ tickets, onTicketClick }) => {
  const sortedTickets = [...tickets].sort(
    (a, b) => new Date(b.lastInteractionAt) - new Date(a.lastInteractionAt)
  )

  if (sortedTickets.length === 0) {
    return (
      <div className='text-center py-8 text-gray-500'>
        No hay tickets disponibles
      </div>
    )
  }

  return (
    <div className='space-y-4'>
      {sortedTickets.map((ticket) => (
        <div
          key={ticket.id}
          onClick={() => onTicketClick(ticket.id)}
          className='border rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors'
        >
          <div className='flex justify-between items-start mb-2'>
            <div className='flex-1'>
              <h3 className='text-lg font-semibold'>{ticket.title}</h3>
              <p className='text-sm text-gray-500 mt-1'>
                {TYPE_LABELS[ticket.type]}
              </p>
            </div>
            <div className='flex items-center gap-2'>
              <span
                className={`px-3 py-1 rounded-full text-xs font-medium ${STATUS_COLORS[ticket.status]}`}
              >
                {STATUS_LABELS[ticket.status]}
              </span>
            </div>
          </div>
          <div className='text-sm text-gray-500'>
            {new Date(ticket.lastInteractionAt).toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
